import React from 'react';

import { useForm } from "react-hook-form";

const sendFeedback = (serviceID, templateId, variables) => {
    window.emailjs.send(
        serviceID, templateId,
        variables
    ).then(res => {
        console.log('Email successfully sent!')
    })
        .catch(err => console.error('There has been an error.  Here some thoughts on the error that occured:', err))
}
const ContactUs = () => {
    const { register, handleSubmit, errors } = useForm();
    const onSubmit = (data, r) => {
        alert(`Thank you for your message from ${data.email}`);
        const templateId = 'template_s99l4h6';
        const serviceID = 'service_qq3quh2';
        sendFeedback(serviceID, templateId, { from_name: data.name, message_html: data.comment, reply_to: data.email })
        r.target.reset();
    }


    return (
        <div className="ContactForm"  >
           
            <form onSubmit={handleSubmit(onSubmit)}>
            <h2>Ask me anything </h2>
                <input 
                class="form-control"
                    placeholder="Name"
                    name="name" 
                    ref={
                        register({ 
                            required: "Please enter your name", 
                            maxLength: {
                                value: 20,
                                message: "Please enter a name with fewer than 20 characters"
                            } 
                        })
                    } 
                /><br />
                {errors.name && errors.name.message}<br />

                <input
                class="form-control"
                    placeholder="Email"
                    name="email"
                    ref={
                        register({
                            required: "Please enter an email",
                            pattern: {
                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                message: "invalid email address"
                            }
                        })
                    }
                /><br/>
                {errors.email && errors.email.message}<br />

                <textarea 
                class="form-control"
                    placeholder="  Message"
                    name="comment" 
                    ref={
                        register({
                            required: true
                        })
                    } 
                /><br />
                {errors.comment && "oops, you forgot your message!"}<br />

                <button className="btn btn-m" style={{backgroundColor:"#f6ce91", color:"#0b5345"}} type="submit">    <h4>Send me your message</h4>  </button>
            </form>
        </div>
    );
}

export default ContactUs;